import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import webServices from '../services/webServices';
import AppConstants from '../appConstants';
import HomeHeaderMobile from '../layouts/partial/homeHeaderMobile';

const UnsubscribeSuccess = () => {
  const { token } = useParams();
  const history = useHistory();
  const [isProcessing, setIsProcessing] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const unsubscribeUser = async () => {
      if (!token) {
        setError('Invalid unsubscribe link');
        setIsProcessing(false);
        return;
      }

      try {
        const response = await webServices.unsubscribeFromEmails(token);
        if (response && response.success) {
          setIsSuccess(true);
          toast.success(response.message || 'Successfully unsubscribed from emails');
        } else {
          setError(response?.message || 'Failed to unsubscribe. Please try again.');
        }
      } catch (err) {
        setError(err?.response?.data?.message || 'An error occurred. Please try again later.');
      } finally {
        setIsProcessing(false);
      }
    };

    unsubscribeUser();
  }, [token]);

  return (
    <>
      <section className="loginWrapper text-light position-relative">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              <HomeHeaderMobile />
            </div>

            <div className="reg-inner">

              {(() => {
                if (isProcessing) {
                  return (
                    <div className="col-12 text-center">
                      <h1 className="mb-4">Processing...</h1>
                      <p>Please wait while we process your request.</p>
                    </div>
                  );
                }
                if (isSuccess) {
                  return (
                    <div className="col-12 text-center">
                      <div className="mb-4">
                        <svg
                          width="80"
                          height="80"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ color: '#B800E0', margin: '0 auto' }}
                        >
                          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
                          <path
                            d="M8 12l2 2 4-4"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <h1 className="mb-4" style={{ color: '#B800E0' }}>
                        Successfully Unsubscribed
                      </h1>
                      <div className="col-12 text-center mb-4">
                        <p className="mb-0" style={{ fontSize: '16px', lineHeight: '1.6' }}>
                          You have been successfully unsubscribed from email notifications.
                          <br />
                          You will no longer receive promotional emails from Lovrican.
                        </p>
                      </div>
                      <div className="col-12 text-center">
                        <p className='link-btn-2'>
                          <span
                            className="link-color cursor-pointer"
                            role="button"
                            tabIndex="0"
                            onClick={() => history.push(AppConstants.routes.home)}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                history.push(AppConstants.routes.home);
                              }
                            }}
                          >
                            Return to Home
                          </span>
                        </p>
                      </div>
                    </div>
                  );
                }
                return (
                  <div className="col-12 text-center">
                    <div className="mb-4">
                      <svg
                        width="80"
                        height="80"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ color: '#dc3545', margin: '0 auto' }}
                      >
                        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
                        <path
                          d="M12 8v4M12 16h.01"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>
                    <h1 className="mb-4" style={{ color: '#dc3545' }}>
                      Unsubscribe Failed
                    </h1>
                    <div className="declaration-box reg-login border-0 mb-4">
                      <p className="mb-0" style={{ fontSize: '16px', lineHeight: '1.6', color: '#dc3545' }}>
                        {error || 'Failed to unsubscribe. The link may be invalid or expired.'}
                      </p>
                    </div>
                    <div className="col-12 text-center link-btn">
                      <p>
                        <span>Return to </span>
                        <span
                          className="link-color cursor-pointer"
                          role="button"
                          tabIndex="0"
                          onClick={() => history.push(AppConstants.routes.home)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              history.push(AppConstants.routes.home);
                            }
                          }}
                        >
                          Home
                        </span>
                      </p>
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default UnsubscribeSuccess;

